module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    staticClass: "form-select",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "blur": _vm.save,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.answer, "atxt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a language")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6513A"
    }
  }, [_vm._v("Acehnese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999E"
    }
  }, [_vm._v("Achang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9201A"
    }
  }, [_vm._v("Acholi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8601A"
    }
  }, [_vm._v("Adnymathanha (Yura Ngawarla)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AY"
    }
  }, [_vm._v("Afar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100B"
    }
  }, [_vm._v("Afghan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299A"
    }
  }, [_vm._v("African Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9200A"
    }
  }, [_vm._v("African Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1403A"
    }
  }, [_vm._v("Afrikaans")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9203A"
    }
  }, [_vm._v("Akan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3901A"
    }
  }, [_vm._v("Albanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8201A"
    }
  }, [_vm._v("Alyawarr (Alyawarra)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9101A"
    }
  }, [_vm._v("American Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9214A"
    }
  }, [_vm._v("Amharic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8101A"
    }
  }, [_vm._v("Anindilyakwa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8202A"
    }
  }, [_vm._v("Anmatyerr (Anmatyirra)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AQ"
    }
  }, [_vm._v("Anuak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8602A"
    }
  }, [_vm._v("Arabana (Arabuna)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4202A"
    }
  }, [_vm._v("Arabic (Including Lebanese)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AM"
    }
  }, [_vm._v("Arabic, Sudanese Creole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999C"
    }
  }, [_vm._v("Arakanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3902A"
    }
  }, [_vm._v("Armenian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3903A"
    }
  }, [_vm._v("Aromunian (Macedo-Romanian)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8203A"
    }
  }, [_vm._v("Arrente (Aranda)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9204A"
    }
  }, [_vm._v("Asante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100C"
    }
  }, [_vm._v("Ashkun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5213A"
    }
  }, [_vm._v("Assamese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4203A"
    }
  }, [_vm._v("Assyrian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4206A"
    }
  }, [_vm._v("Assyrian Neo-Aramaic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9701A"
    }
  }, [_vm._v("Auslan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8700A"
    }
  }, [_vm._v("Australian Creoles (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8000A"
    }
  }, [_vm._v("Australian Indigenous/Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4302A"
    }
  }, [_vm._v("Azeri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6514A"
    }
  }, [_vm._v("Balinese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4104A"
    }
  }, [_vm._v("Balochi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3100A"
    }
  }, [_vm._v("Baltic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8204A"
    }
  }, [_vm._v("Bardi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299H"
    }
  }, [_vm._v("Bari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2901A"
    }
  }, [_vm._v("Basque")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299I"
    }
  }, [_vm._v("Bassa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3401A"
    }
  }, [_vm._v("Belorussian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9215A"
    }
  }, [_vm._v("Bemba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AD"
    }
  }, [_vm._v("Bembe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5201A"
    }
  }, [_vm._v("Bengali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6515A"
    }
  }, [_vm._v("Bikol")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6501A"
    }
  }, [_vm._v("Bisaya/Visaya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9402A"
    }
  }, [_vm._v("Bislama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3501A"
    }
  }, [_vm._v("Bosnian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3502A"
    }
  }, [_vm._v("Bulgarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8205A"
    }
  }, [_vm._v("Bunuba (Bunaba)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8102A"
    }
  }, [_vm._v("Burarra")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6100A"
    }
  }, [_vm._v("Burmese and Related Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7101A"
    }
  }, [_vm._v("Cantonese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8399A"
    }
  }, [_vm._v("Cape York Pen Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8300A"
    }
  }, [_vm._v("Cape York Pen Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2301A"
    }
  }, [_vm._v("Catalan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6502A"
    }
  }, [_vm._v("Cebuano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1199A"
    }
  }, [_vm._v("Celtic, nec ( Breton, Cornish, Manz)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1100A"
    }
  }, [_vm._v("Celtic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8299A"
    }
  }, [_vm._v("Central Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8200A"
    }
  }, [_vm._v("Central Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4299B"
    }
  }, [_vm._v("Chaldaean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4203B"
    }
  }, [_vm._v("Chaldean Neo-Aramaic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AV"
    }
  }, [_vm._v("Chiga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7100B"
    }
  }, [_vm._v("Chin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69996"
    }
  }, [_vm._v("Chin Daai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999E"
    }
  }, [_vm._v("Chin Falam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999D"
    }
  }, [_vm._v("Chin Haka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999F"
    }
  }, [_vm._v("Chin Khumi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999G"
    }
  }, [_vm._v("Chin Mara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999H"
    }
  }, [_vm._v("Chin Mro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999I"
    }
  }, [_vm._v("Chin Mun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999J"
    }
  }, [_vm._v("Chin Ngawn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999K"
    }
  }, [_vm._v("Chin Senthang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999L"
    }
  }, [_vm._v("Chin Teddim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999M"
    }
  }, [_vm._v("Chin Thado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999N"
    }
  }, [_vm._v("Chin Zome")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999O"
    }
  }, [_vm._v("Chin Zotong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7199A"
    }
  }, [_vm._v("Chinese, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7100A"
    }
  }, [_vm._v("Chinese, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9209A"
    }
  }, [_vm._v("Comorian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3503A"
    }
  }, [_vm._v("Croatian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3601A"
    }
  }, [_vm._v("Czech")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3604A"
    }
  }, [_vm._v("Czechoslovakian, so described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299C"
    }
  }, [_vm._v("Dagbani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AO"
    }
  }, [_vm._v("Daju, Dar Daju")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AP"
    }
  }, [_vm._v("Daju, Dar Sila")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1501A"
    }
  }, [_vm._v("Danish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4105A"
    }
  }, [_vm._v("Dari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8103A"
    }
  }, [_vm._v("Dhaangu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8104A"
    }
  }, [_vm._v("Dhayyi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5214A"
    }
  }, [_vm._v("Dhivehi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8105A"
    }
  }, [_vm._v("Dhuwal-Dhuwala")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9216A"
    }
  }, [_vm._v("Dinka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8106A"
    }
  }, [_vm._v("Djinang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5199A"
    }
  }, [_vm._v("Dravidian, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5100A"
    }
  }, [_vm._v("Dravidian, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1401A"
    }
  }, [_vm._v("Dutch")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999B"
    }
  }, [_vm._v("Dzonkha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7000A"
    }
  }, [_vm._v("EASTERN ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3000A"
    }
  }, [_vm._v("EASTERN EUROPEAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3400A"
    }
  }, [_vm._v("East Slavic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8699A"
    }
  }, [_vm._v("Eastern Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8600A"
    }
  }, [_vm._v("Eastern Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6199C"
    }
  }, [_vm._v("Eastern Kayah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1201A"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1601A"
    }
  }, [_vm._v("Estonian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9217A"
    }
  }, [_vm._v("Ewe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1599B"
    }
  }, [_vm._v("Faeroese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9301A"
    }
  }, [_vm._v("Fijian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5217A"
    }
  }, [_vm._v("Fijian Hindustani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6512A"
    }
  }, [_vm._v("Filipino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3299A"
    }
  }, [_vm._v("Finnic, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3200A"
    }
  }, [_vm._v("Finnic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1602A"
    }
  }, [_vm._v("Finnish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1401C"
    }
  }, [_vm._v("Flemish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AB"
    }
  }, [_vm._v("Fon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2101A"
    }
  }, [_vm._v("French")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1402A"
    }
  }, [_vm._v("Frisian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9245A"
    }
  }, [_vm._v("Fulfulde")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AE"
    }
  }, [_vm._v("Fuliiru")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299F"
    }
  }, [_vm._v("Fullah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AR"
    }
  }, [_vm._v("Fur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9218A"
    }
  }, [_vm._v("Ga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1101A"
    }
  }, [_vm._v("Gaelic (Scotland)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4902A"
    }
  }, [_vm._v("Georgian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1301A"
    }
  }, [_vm._v("German")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9302A"
    }
  }, [_vm._v("Gilbertese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299K"
    }
  }, [_vm._v("Gio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299L"
    }
  }, [_vm._v("Grebo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2201A"
    }
  }, [_vm._v("Greek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8301A"
    }
  }, [_vm._v("Gugu Yalanji")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5202A"
    }
  }, [_vm._v("Gujarati")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8302A"
    }
  }, [_vm._v("Guugu Yimidhirr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299G"
    }
  }, [_vm._v("Hadiyigna")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6102A"
    }
  }, [_vm._v("Haka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7102A"
    }
  }, [_vm._v("Hakka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9221A"
    }
  }, [_vm._v("Harari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9222A"
    }
  }, [_vm._v("Hausa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9404A"
    }
  }, [_vm._v("Hawaiian English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100G"
    }
  }, [_vm._v("Hazaragi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4204A"
    }
  }, [_vm._v("Hebrew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92993"
    }
  }, [_vm._v("Hemba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5203A",
      "selected": "selected"
    }
  }, [_vm._v("Hindi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6201A"
    }
  }, [_vm._v("Hmong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6299A"
    }
  }, [_vm._v("Hmong-Mien, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6200A"
    }
  }, [_vm._v("Hmong-Mien, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7103A"
    }
  }, [_vm._v("Hokkien")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999P"
    }
  }, [_vm._v("Hpon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3301A"
    }
  }, [_vm._v("Hungarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6516A"
    }
  }, [_vm._v("Iban")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2399A"
    }
  }, [_vm._v("Iberian Romance, nec (includes Crioulo, Galaician, Ladino)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2300A"
    }
  }, [_vm._v("Iberian Romance, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1502A"
    }
  }, [_vm._v("Icelandic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9223A"
    }
  }, [_vm._v("Igbo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6503A"
    }
  }, [_vm._v("Iiokano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6517A"
    }
  }, [_vm._v("Ilonggo (Hiligaynon)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0000A"
    }
  }, [_vm._v("Inadequately Described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000B"
    }
  }, [_vm._v("Indian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5299A"
    }
  }, [_vm._v("Indo-Aryan, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5200A"
    }
  }, [_vm._v("Indo-Aryan, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6504A"
    }
  }, [_vm._v("Indonesian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9601A"
    }
  }, [_vm._v("Invented Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4199A"
    }
  }, [_vm._v("Iranic, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100A"
    }
  }, [_vm._v("Iranic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1102A"
    }
  }, [_vm._v("Irish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2401A"
    }
  }, [_vm._v("Italian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7201A"
    }
  }, [_vm._v("Japanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8206A"
    }
  }, [_vm._v("Jaru (Djaru)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6518A"
    }
  }, [_vm._v("Javanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AG"
    }
  }, [_vm._v("Joba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6199B"
    }
  }, [_vm._v("Kachin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299M"
    }
  }, [_vm._v("Kakwa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8401A"
    }
  }, [_vm._v("Kalaw Lagaw Ya (Kalaw Kawa Ya)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5101A"
    }
  }, [_vm._v("Kannada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6103A"
    }
  }, [_vm._v("Karen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999Q"
    }
  }, [_vm._v("Karen Brek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999R"
    }
  }, [_vm._v("Karen Bwe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999S"
    }
  }, [_vm._v("Karen Gebe")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999T"
    }
  }, [_vm._v("Karen Geko")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999U"
    }
  }, [_vm._v("Karen Manumanaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999V"
    }
  }, [_vm._v("Karen Paku")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999W"
    }
  }, [_vm._v("Karen Pwo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999X"
    }
  }, [_vm._v("Karen S'gaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999Y"
    }
  }, [_vm._v("Karen Yinbaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999Z"
    }
  }, [_vm._v("Karen Yintale")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69991"
    }
  }, [_vm._v("Karen Zayein")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8107A"
    }
  }, [_vm._v("Karrwa (Garrwa, Garawa)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5215A"
    }
  }, [_vm._v("Kashmiri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100D"
    }
  }, [_vm._v("Kati")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4399B"
    }
  }, [_vm._v("Kazakh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6301A"
    }
  }, [_vm._v("Khmer/Cambodian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8207A"
    }
  }, [_vm._v("Kija (Gidya)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9224A"
    }
  }, [_vm._v("Kikuyu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299N"
    }
  }, [_vm._v("Kinyarwanda / Rwanda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299O"
    }
  }, [_vm._v("Kirundi / Nyarwandwa / Rundi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299P"
    }
  }, [_vm._v("Kissi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9502A"
    }
  }, [_vm._v("Kiwai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5204A"
    }
  }, [_vm._v("Konkani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92990"
    }
  }, [_vm._v("Kono (Sierra Leone)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AF"
    }
  }, [_vm._v("Koongo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7301A"
    }
  }, [_vm._v("Korean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299Q"
    }
  }, [_vm._v("Kpelle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299R"
    }
  }, [_vm._v("Krahn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9205B"
    }
  }, [_vm._v("Kreole / Creole (African)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8701B"
    }
  }, [_vm._v("Krieole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9225A"
    }
  }, [_vm._v("Krio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8701A"
    }
  }, [_vm._v("Kriol")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299S"
    }
  }, [_vm._v("Kru")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8212A"
    }
  }, [_vm._v("Kukatha (Gugaja)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8211A"
    }
  }, [_vm._v("Kukatha (Kokatha, Gugada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299T"
    }
  }, [_vm._v("Kuku")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8108A"
    }
  }, [_vm._v("Kunwinjku (Gunwinggu)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92994"
    }
  }, [_vm._v("Kuranko")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4101A"
    }
  }, [_vm._v("Kurdish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8303A"
    }
  }, [_vm._v("Kuuku-Yau")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8208A"
    }
  }, [_vm._v("Kuurinji (Gurindji)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AT"
    }
  }, [_vm._v("Laka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AW"
    }
  }, [_vm._v("Lango")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6401A"
    }
  }, [_vm._v("Lao")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69992"
    }
  }, [_vm._v("Lashi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2902A"
    }
  }, [_vm._v("Latin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3101A"
    }
  }, [_vm._v("Latvian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1302A"
    }
  }, [_vm._v("Letzeburgish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AA"
    }
  }, [_vm._v("Liberian English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299U"
    }
  }, [_vm._v("Limba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92992"
    }
  }, [_vm._v("Lingala")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999F"
    }
  }, [_vm._v("Lisu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3102A"
    }
  }, [_vm._v("Lithuanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92995"
    }
  }, [_vm._v("Loko")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92996"
    }
  }, [_vm._v("Lokoya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299V"
    }
  }, [_vm._v("Loma / Lorma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AK"
    }
  }, [_vm._v("Luba-Kasai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9226A"
    }
  }, [_vm._v("Luganda / Ganda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9254A"
    }
  }, [_vm._v("Lumun (Kuku Lumun)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9227A"
    }
  }, [_vm._v("Luo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92997"
    }
  }, [_vm._v("Luwo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3504A"
    }
  }, [_vm._v("Macedonian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299E"
    }
  }, [_vm._v("Madi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9702A"
    }
  }, [_vm._v("Makaton")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6505A"
    }
  }, [_vm._v("Malay")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5102A"
    }
  }, [_vm._v("Malayalam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2501A"
    }
  }, [_vm._v("Maltese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4208A"
    }
  }, [_vm._v("Mandaean (Mandaic)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7104A"
    }
  }, [_vm._v("Mandarin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299W"
    }
  }, [_vm._v("Mandingo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299X"
    }
  }, [_vm._v("Mano")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9303A"
    }
  }, [_vm._v("Maori (Cook Island)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9304A"
    }
  }, [_vm._v("Maori (New Zealand)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5205A"
    }
  }, [_vm._v("Marathi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69993"
    }
  }, [_vm._v("Maru")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8111A"
    }
  }, [_vm._v("Maung")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9205A"
    }
  }, [_vm._v("Mauritian Creole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299Y"
    }
  }, [_vm._v("Mende")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8402A"
    }
  }, [_vm._v("Meryam Mir")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4299A"
    }
  }, [_vm._v("Middle Eastern Semitic Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4200A"
    }
  }, [_vm._v("Middle Eastern Semitic Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7107A"
    }
  }, [_vm._v("Min Nan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AC"
    }
  }, [_vm._v("Mina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8213A"
    }
  }, [_vm._v("Miriwoong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6303A"
    }
  }, [_vm._v("Mon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6399A"
    }
  }, [_vm._v("Mon-Khmer, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6300A"
    }
  }, [_vm._v("Mon-Khmer, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7902A"
    }
  }, [_vm._v("Mongolian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92998"
    }
  }, [_vm._v("Moro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9305A"
    }
  }, [_vm._v("Motu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8112A"
    }
  }, [_vm._v("Murrinh-Patha")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8214A"
    }
  }, [_vm._v("Mutpurra (Mudburra)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1000A"
    }
  }, [_vm._v("NORTHERN EUROPEAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9306A"
    }
  }, [_vm._v("Nauruan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9228A"
    }
  }, [_vm._v("Ndebele")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1401B"
    }
  }, [_vm._v("Nederlands")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5206A"
    }
  }, [_vm._v("Nepali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8215A"
    }
  }, [_vm._v("Ngaatjatjara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8113A"
    }
  }, [_vm._v("Ngangkikurungurr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8501A"
    }
  }, [_vm._v("Ngarluma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9307A"
    }
  }, [_vm._v("Niue")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0001A"
    }
  }, [_vm._v("Non-Verbal So Described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8199A"
    }
  }, [_vm._v("Northern Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8100A"
    }
  }, [_vm._v("Northern Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1503A"
    }
  }, [_vm._v("Norwegian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0002A"
    }
  }, [_vm._v("Not Stated")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AU"
    }
  }, [_vm._v("Nubi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9231A"
    }
  }, [_vm._v("Nuer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69994"
    }
  }, [_vm._v("Nung")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8114A"
    }
  }, [_vm._v("Nunggubuyu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8216A"
    }
  }, [_vm._v("Nyangumarta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9232A"
    }
  }, [_vm._v("Nyanja (Chichewa)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8502A"
    }
  }, [_vm._v("Nyungar (Noongar)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9000A"
    }
  }, [_vm._v("OTHER LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9499A"
    }
  }, [_vm._v("Oceanian Pidgins And Creoles, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9400A"
    }
  }, [_vm._v("Oceanian Pidgins And Creoles, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5216A"
    }
  }, [_vm._v("Oriya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9206A"
    }
  }, [_vm._v("Oromo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999A"
    }
  }, [_vm._v("Other Eastern Asian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3999A"
    }
  }, [_vm._v("Other Eastern European Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3900A"
    }
  }, [_vm._v("Other Eastern European Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999A"
    }
  }, [_vm._v("Other Southeast Asian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5999A"
    }
  }, [_vm._v("Other Southern Asian Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2999A"
    }
  }, [_vm._v("Other Southern European Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2900A"
    }
  }, [_vm._v("Other Southern European Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4999A"
    }
  }, [_vm._v("Other Southwest and Central Asian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9399A"
    }
  }, [_vm._v("Pacific Austronesian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9300A"
    }
  }, [_vm._v("Pacific Austronesian Languages, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0000B"
    }
  }, [_vm._v("Pakistani")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6521A"
    }
  }, [_vm._v("Pampangan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4103E"
    }
  }, [_vm._v("Panjsheri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9599A"
    }
  }, [_vm._v("Papua New Guinea Papuan Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9501A"
    }
  }, [_vm._v("Papuan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100E"
    }
  }, [_vm._v("Parsun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4102A"
    }
  }, [_vm._v("Pashto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4106A"
    }
  }, [_vm._v("Persian (excluding Dari)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4103A"
    }
  }, [_vm._v("Persian/Farsi/Dari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8217A"
    }
  }, [_vm._v("Pintupi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9403A"
    }
  }, [_vm._v("Pitcairnese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8218A"
    }
  }, [_vm._v("Pitjantjatjara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3602A"
    }
  }, [_vm._v("Polish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2302A"
    }
  }, [_vm._v("Portuguese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299D"
    }
  }, [_vm._v("Pular / Fuuta Jalon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5207A"
    }
  }, [_vm._v("Punjabi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AH"
    }
  }, [_vm._v("Punu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8115A"
    }
  }, [_vm._v("Rembarrnga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8116A"
    }
  }, [_vm._v("Ritharrngu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5201B"
    }
  }, [_vm._v("Rohingya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3904A"
    }
  }, [_vm._v("Romanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3905A"
    }
  }, [_vm._v("Romany")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9312A"
    }
  }, [_vm._v("Rotuman")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3402A"
    }
  }, [_vm._v("Russian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6000A"
    }
  }, [_vm._v("SOUTHEAST ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000A"
    }
  }, [_vm._v("SOUTHERN ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2000A"
    }
  }, [_vm._v("SOUTHERN EUROPEAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4000A"
    }
  }, [_vm._v("SOUTHWEST AND CENTRAL ASIAN LANGUAGES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9308A"
    }
  }, [_vm._v("Samoan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AJ"
    }
  }, [_vm._v("Sango")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6999B"
    }
  }, [_vm._v("Sasak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1599A"
    }
  }, [_vm._v("Scandinavian, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1500A"
    }
  }, [_vm._v("Scandinavian, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3505A"
    }
  }, [_vm._v("Serbian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3507A"
    }
  }, [_vm._v("Serbo-Croatian/Yugoslavian, so described")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9238A"
    }
  }, [_vm._v("Seychelles Creole")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69995"
    }
  }, [_vm._v("Shan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9233A"
    }
  }, [_vm._v("Shilluk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9207A"
    }
  }, [_vm._v("Shona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9799A"
    }
  }, [_vm._v("Sign Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9700A"
    }
  }, [_vm._v("Sign Languages,nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5208A"
    }
  }, [_vm._v("Sindhi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5211A"
    }
  }, [_vm._v("Sinhalese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3603A"
    }
  }, [_vm._v("Slovak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3506A"
    }
  }, [_vm._v("Slovene")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9405A"
    }
  }, [_vm._v("Solomon Islands Pijin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9208A"
    }
  }, [_vm._v("Somali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AI"
    }
  }, [_vm._v("Songo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3500A"
    }
  }, [_vm._v("South Slavic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6500A"
    }
  }, [_vm._v("Southeast Asian Austronesian Languages")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6599A"
    }
  }, [_vm._v("Southeast Asian Austronesian Languages, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2303A"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5000C"
    }
  }, [_vm._v("Sri Lankan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299Z"
    }
  }, [_vm._v("Susu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9211A"
    }
  }, [_vm._v("Swahili")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1504A"
    }
  }, [_vm._v("Swedish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999C"
    }
  }, [_vm._v("Szi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6506A"
    }
  }, [_vm._v("Tagalog (Filipino)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6499A"
    }
  }, [_vm._v("Tai, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6400A"
    }
  }, [_vm._v("Tai, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5103A"
    }
  }, [_vm._v("Tamil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4303A"
    }
  }, [_vm._v("Tatar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5104A"
    }
  }, [_vm._v("Telugu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299J"
    }
  }, [_vm._v("Temne / Themne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7105A"
    }
  }, [_vm._v("Teochew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6507A"
    }
  }, [_vm._v("Tetum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6402A"
    }
  }, [_vm._v("Thai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7901A"
    }
  }, [_vm._v("Tibetan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9234A"
    }
  }, [_vm._v("Tigre")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9235A"
    }
  }, [_vm._v("Tigrinya")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6508A"
    }
  }, [_vm._v("Timorese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8117A"
    }
  }, [_vm._v("Tiwi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9401A"
    }
  }, [_vm._v("Tok Pisin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9313A"
    }
  }, [_vm._v("Tokelauan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9311A"
    }
  }, [_vm._v("Tongan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8400A"
    }
  }, [_vm._v("Torres Strait (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8702A"
    }
  }, [_vm._v("Torres Strait Creole (Broken)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9236A"
    }
  }, [_vm._v("Tswana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5105A"
    }
  }, [_vm._v("Tulu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4399A"
    }
  }, [_vm._v("Turkic, nec")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4300A"
    }
  }, [_vm._v("Turkic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4301A"
    }
  }, [_vm._v("Turkish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4304A"
    }
  }, [_vm._v("Turkmen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9314A"
    }
  }, [_vm._v("Tuvaluan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9203B"
    }
  }, [_vm._v("Twi (Akan)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3403A"
    }
  }, [_vm._v("Ukrainian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3500B"
    }
  }, [_vm._v("Unspec.Fmr.Yugoslav Language")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5212A"
    }
  }, [_vm._v("Urdu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4305A"
    }
  }, [_vm._v("Uygur / Uyghur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4306A"
    }
  }, [_vm._v("Uzbek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "92991"
    }
  }, [_vm._v("Vai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6302A"
    }
  }, [_vm._v("Vietnamese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4100F"
    }
  }, [_vm._v("Waigali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8221A"
    }
  }, [_vm._v("Walmajarri (Walmadjari)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8223A"
    }
  }, [_vm._v("Warlpiri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8222A"
    }
  }, [_vm._v("Warumungu (Warumunga)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1103A"
    }
  }, [_vm._v("Welsh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8599A"
    }
  }, [_vm._v("West Coast Aboriginal (NEC)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8500A"
    }
  }, [_vm._v("West Coast Aboriginal (NFD)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3600A"
    }
  }, [_vm._v("West Slavic, nfd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8304A"
    }
  }, [_vm._v("Wik-Mungkan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7106A"
    }
  }, [_vm._v("Wu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9237A"
    }
  }, [_vm._v("Xhosa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AL"
    }
  }, [_vm._v("Yakoma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8225A"
    }
  }, [_vm._v("Yankuntjatjara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8118A"
    }
  }, [_vm._v("Yanyuwa (Anula)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9315A"
    }
  }, [_vm._v("Yapese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1303A"
    }
  }, [_vm._v("Yiddish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8503A"
    }
  }, [_vm._v("Yindjibarndi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9212A"
    }
  }, [_vm._v("Yoruba")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8224A"
    }
  }, [_vm._v("Yulparija")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AS"
    }
  }, [_vm._v("Zaghawa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7999D"
    }
  }, [_vm._v("Zaiwa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9299AN"
    }
  }, [_vm._v("Zande")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "69997"
    }
  }, [_vm._v("Zophei")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9213A"
    }
  }, [_vm._v("Zulu")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile-action"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58eb8f5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/questions/language.vue
// module id = 502
// module chunks = 1